
module.config(function($stateProvider) {

    $stateProvider.state('student.admin', {
        url: '/admin',
        permission: 'administerStudents',
        templateUrl: 'students/admin/page',
        abstract: true,
    });

    $stateProvider.state('student.admin.issues', {
        url: '',
        templateUrl: "students/admin/issues",
        resolve: {
            issues: function(student, ModelService) {
                return ModelService.getModelRelation(student, 'issues/aggregate');
            },
        },
        controllerAs: 'ctrl',
        controller: module.cC({
            inject: ['student', 'issues', 'ModelService'],
            data: {
                showIssues: '{}',
            },
            listen: {
                participant: {
                    issues: '_refreshIssues',
                },
            },
            methods: {
                rebuildIssues: function() {
                    return this.ModelService.postModelRelation(this.student,
                        'issues/all');
                },

                _refreshIssues: function(participantId) {
                    var issues = this.issues;
                    if (participantId === this.student.id) {
                        this.ModelService.debouncedRelation('participant', this.student.id, 'issues/aggregate')
                            .then(function(newIssues) {
                                angular.copy(newIssues, issues);
                            })
                    }
                },
            },
        }),
    });

    $stateProvider.state('student.admin.manage', {
        url: '/manage',
        templateUrl: 'students/admin/manage',
        controllerAs: 'ctrl',
        controller: module.cC({
            inject: ['$state', 'program', 'student', 'ModelService'],
            data: {
                hasEnrollment: 'student.has_enrollment',
            },
            init: function() {
                console.log(this);
            },
            methods: {
                deleteStudent: function() {
                    return this.ModelService.deleteModel(this.student);
                },

                createEnrollment: function() {
                    return this.ModelService.postModelRelation(this.student, 'enrollment', {})
                },

                deleteEnrollment: function() {
                    return this.ModelService.delete('enrollment', this.student.id);
                },

                deleteDone: function() {
                    this.$state.go(
                        this.student.has_enrollment ? 'students' : 'participants',
                        {slug: this.program.slug});
                },
            },
        }),
    });
});